<template>
  <tag color="sapphire" fa-icon="stars fas" class="our-pick-badge">
    Our pick
  </tag>
</template>

<script>
import Tag from '@components/tag/tag.vue';

export default {
  components: {
    Tag,
  },
};
</script>

<style lang="scss" scoped>
.our-pick-badge {
  & :deep(.fas:not(.fa-asterisk)) {
    color: var(--sapphire-100);
  }
}
</style>
